module.exports = __webpack_public_path__ + "static/media/aqua1.19d66aaf.jpg";